import {Component, Input} from "@angular/core";
import {User} from "../../../objects/users/user";
import {AgentModalComponent} from "../modal/agent-modal.component";
import {UserHelper} from "../../../common/helpers/userHelper";
/**
 * Created by vlad.p on 7/31/2017.
 */

@Component({
    selector: 'agent-item',
    templateUrl: 'agent-item.component.html',
    moduleId: module.id.toString()
})
export class AgentItemComponent {

    @Input()
    public agent: User;

    public userHelper = UserHelper;
    public string = String;

    @Input()
    public agentModal: AgentModalComponent;

}


// WEBPACK FOOTER //
// ./app/components/agent/agent-item/agent-item.component.ts